import React from 'react'
import { Link} from 'gatsby'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Card from 'react-bootstrap/Card'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDoubleRight } from '@fortawesome/free-solid-svg-icons'
import './RelatedContent.css'

const RelatedContent = ({ relatedContent }) => {
    if (relatedContent.length === 0 || relatedContent[0].related_content.document == null) return null
    else
    return (
    <div className="mt-4 clear-both">
    <hr/>
    <h2 className="h4">Related Content</h2>
    <Row className="row-flex">
     {relatedContent.map((item) => {
         return <Col md={6} className="my-2 " key={item.related_content.uid}>
            <Card className="border-top-accent-cool bg-white h-80 related-content-card">
                <Card.Body className="related-content-card-body">
                    <h3 className="related-content-h6 card-title">
                        {item.related_content.document.data.title}
                        <FontAwesomeIcon icon={faAngleDoubleRight} size="lg" className="float-right"/>
                    </h3>
                </Card.Body>
                <Card.Footer className="related-content-card-footer">
                    <Link className="stretched-link related-content-stretched-link" to={ item.related_content.url }>  
                        <span className="sr-only">View {item.related_content.document.data.title}</span> 
                    </Link>
                </Card.Footer>
            </Card>
        </Col>
     })}
     </Row>
    </div>
    )
}

export default RelatedContent;